import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { Portal } from '../Portal/Portal';
const Center = styled.div `
  min-height: calc(100% - 3.5rem);
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
  transition: 0.3s;
`;
const ModalContainer = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: block;
  transition: 0.3s;
  z-index: ${(props) => props.zIndex};
  overflow: auto;
`;
const ModalComponentInner = styled.div `
  background: #ffffff;
  margin: 0 20px;
  border-radius: ${(props) => (props.nBr ? '0' : '8px')};
  border: 1px solid #e5e7eb;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  position: relative;
`;
const ModalComponent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px auto;
  cursor: auto;

  position: relative;
  span {
    position: absolute;
    right: 20px;
    top: 15px;
    cursor: pointer;
    z-index: 9999;
    font-size: 18px;
  }
`;
const ModalContainerNew = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(39, 39, 36, 0.5);
  display: block;
  transition: 0.3s;
  z-index: 99999;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ModalComponentInnerNew = styled.div `
  position: relative;
  margin: auto;
  border-radius: 12px;
  background: #292c2e;
  box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.39);
  z-index: 10000;
  overflow: hidden;
  margin-top: 60px;

  ${({ eventModal }) => eventModal &&
    `
    margin: 0;
    background: none;
    box-shadow: none;
    overflow: visible;
    max-height: 100vh;
    padding: 10px 0;
  `}

  ${({ lightShadow }) => lightShadow &&
    `
      box-shadow: 0px 21px 47px rgba(0, 0, 0, 0.31);
  `}

  .close {
    position: absolute;
    right: 22px;
    top: 22px;
    cursor: pointer;
    z-index: 9999;
  }
`;
export function Modal({ children, onClose, width, zIndex = '99999', mobMarg, close, nBr }) {
    const handleContainerClick = (e) => {
        if (e.currentTarget === e.target) {
            onClose();
        }
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx(Portal, { children: _jsx(ModalContainer, Object.assign({ zIndex: zIndex, onClick: handleModalClick }, { children: _jsx(Center, Object.assign({ onClick: handleContainerClick }, { children: _jsx(ModalComponent, Object.assign({ width: width, mobMarg: mobMarg }, { children: _jsxs(ModalComponentInner, Object.assign({ nBr: nBr }, { children: [close && (_jsx("span", Object.assign({ role: "button", tabIndex: 0, className: "close", onKeyDown: () => null, onClick: (e) => {
                                    onClose();
                                } }, { children: "\u00D7" }), "modal")), children] })) })) })) })) }));
}
export function ModalNew({ children, onClose, close, eventModal, lightShadow }) {
    const handleContainerClick = (e) => {
        if (e.currentTarget === e.target) {
            e.stopPropagation();
            e.preventDefault();
            onClose();
        }
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx(Portal, { children: _jsx(ModalContainerNew, Object.assign({ onClick: handleContainerClick }, { children: _jsxs(ModalComponentInnerNew, Object.assign({ onClick: handleModalClick, eventModal: eventModal, lightShadow: lightShadow }, { children: [close && _jsx(CloseIcon, { sx: { color: '#fff' }, className: "close", onClick: onClose }), children] })) })) }));
}
Modal.defaultProps = {
    width: 0,
    zIndex: '99999',
    mobMarg: false,
    close: false,
    nBr: false,
};
ModalNew.defaultProps = {
    close: false,
    eventModal: false,
    lightShadow: false,
};
